<template>
    <div class="updatesProtocol_box">
        <van-popup v-model="show" round :close-on-click-overlay='false' :style="{ width: '85%' }">
            <div class="pop_box">
                <img src="../../../static/image/updatesIcon.svg" alt="">
                <p class="title_p">{{title}}</p>
                <p class="content_p">
                    {{content}}
                    <span style="color:#2660CE" v-for="item in protocol" :key="item.id" @click="handleProtocol(item.id)">{{item.name}}</span>
                </p>
                <div class="btn_box">
                    <van-button class="btn1" type="primary" @click="handleNoAgree">不同意</van-button>
                    <van-button class="btn2" type="primary" @click="handleAgree">同意</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    name:'updatesProtocol',
    props:{
        title: {
            type: String,
            default: ''
        },
        protocol: {
            type: Array,
            default: ''
        },
        content: {
            type: String,
            default: '为充分保护您的权利，详细披露了如何收集、处理、共享您的个人信息。详见'
        },
    },
    data() {
        return {
            show:false
        }
    },

    methods:{
        // 查看协议
        handleProtocol(id) {
            this.$emit('handleProtocol',id)
        },

        // 同意
        handleAgree(id) {
            this.$emit('handleAgree')
        },

        // 不同意
        handleNoAgree(id) {
            this.$emit('handleNoAgree')
        },
    }
}
</script>

<style lang="less" scoped>
.updatesProtocol_box {
    padding: 0 30px;
    .pop_box {
        padding: 30px 20px;
        text-align: center;
        .title_p {
            margin-top: 10px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #3B3B3B;
        }
        .content_p {
            margin-top: 15px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
            text-align: left;
        }
        .btn_box {
            display: flex;
            justify-content: center;
            margin-top: 30px;
            .btn1 {
                margin-right:15px;
                background-color: #f0f0f0;
                color: #777777;
                font-size: 13px;
                width: 120px;
                height: 40px;
                border: none;
            }
            .btn2 {
                background-color: #2E55E5;
                width: 120px;
                height: 40px;
                border: none;
                font-size: 13px;
                color: #FFFFFF;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/modules/Allpopup/updatesProtocol.vue